import { Skeleton } from '@monksflow/monks-ui';

const ROWS = [0, 1, 2];

/** Shared by both panel bodies, so the flag does not change what loading looks like. */
export function CommentsSkeletonList() {
  return (
    <ul className="flex flex-col gap-4" aria-hidden>
      {ROWS.map((row) => (
        <li key={row} className="flex gap-2">
          <Skeleton className="size-7 shrink-0 rounded-full" />
          <div className="flex flex-1 flex-col gap-1.5">
            <Skeleton className="h-3 w-24 rounded-sm" />
            <Skeleton className="h-3 w-full rounded-sm" />
            <Skeleton className="h-3 w-2/3 rounded-sm" />
          </div>
        </li>
      ))}
    </ul>
  );
}
